<div class="d-md-flex justify-content-between align-items-center">
  @if (largetitle !== 'true') {
  <h4>{{ title }}</h4>
  } @if (largetitle === 'true') {
  <h1>{{ title }}</h1>
  } @if (to) {
  <link-icon class="" name="arrow-right" [to]="to">{{ linktitle || 'Overview' }}</link-icon>
  }
</div>
<ng-content></ng-content>
